import Message from './message';

export { mapJsonToActions as messageJsonToPropsJsonActions, default as messageJsonToProps } from './jsonToProps';

export default Message;
